import axios from 'axios';


const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || (process.env.NODE_ENV === 'production' 
        ? 'https://backend-contract2.artimetrik.com/api'
        : 'http://localhost:8080/api'),
    headers: {
        Accept: "application/json, text/plain, */*",
    },
});

// Request interceptor to attach JWT token to each request
apiClient.interceptors.request.use(config => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});
apiClient.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            const isLoginRequest = error.config && error.config.url && error.config.url.includes('/auth/signin');
            if (!isLoginRequest) {
                localStorage.removeItem('jwtToken');
                window.location.href = '/signin';
            }
        }
        return Promise.reject(error);
    }
);


export default apiClient;
